(function() {
  'use strict';

  function coleta() {

    /*@ngInject*/
    function controller (
        $scope, $rootScope, $mdToast, $q,
      $uibModal, $timeout, Pedido,
      Perfil, Encomenda, Historico, Coleta) {

          var vm = this;

          vm.situacoesConcluidas = ['ACaminhoMandae', 'ChegouMandae', 'Concluida'];

          vm.onEnderecoAtualizado = function (endereco) {
            showAlert('Ok, o endereço foi atualizado!');
            vm.pedido.endereco = endereco;
          }

          vm.onError = function (message) {
            showAlert(message);
          }

          vm.atualizar = () => {
            vm.atualizarColeta();

            $rootScope.$broadcast('coleta-atualizada');
          }

          vm.atualizarColeta = () => {
            vm.mostrarColeta = false;
            vm.mostrarCarregando = true;
            vm.user = JSON.parse(localStorage.getItem('ls.user'));

            Perfil.getBetaFeatures().then(function (data){
              vm.mostrarPrevisaoChegadaColaborador = data['funcionalidades'].find(function (feature){
                return feature['codigo'] == 'previsao-chegada-colaborador';
              })['possuiAcesso']
            });

            return $q.all([
              Perfil.getUserData(true),
              Perfil.getClienteData(vm.user.id),
              Historico.userHasSecuriryPickUp(vm.user.id),

              Pedido.buscarResumo($scope.pedidoId),
              Pedido.getPedidoPorId($scope.pedidoId),
              Historico.checkPickupReceipt($scope.pedidoId)
            ])
            .then(function(values){
              vm.user = Object.assign(values[0], values[1]);
              vm.showReleaseAlert = values[2].response;
              vm.user.ativo = vm.user.situacaoCadastral === 'ATIVO';
              vm.user.freedomProgramada = vm.user.planoContrato.tipo == 'FREEDOM' && vm.user.formaColeta == 'Agendada';

              vm.user.enderecos = vm.user.enderecos.filter(function(end) { return end.coletaHabilitada; });

              if(vm.user.situacao == 'BLOQUEADO' && vm.user.freedomProgramada) {
                $uibModal.open({
                  animation: false,
                  template: require('../../modal/modal-servico-suspenso/modal-servico-suspenso.html'),
                  controller: 'ModalServicoSuspensoCtrl',
                  windowClass: 'agendamento-coleta-bloqueado',
                  resolve: {
                    redirectToEncomendas: function() { return true; },
                    nomeOperacao: function() { return 'o envio de suas encomendas'; }
                  }
                });
                return;
              }

              vm.pedido = Object.assign(values[3], values[4]);
              vm.pedido.hasPickupReceipt = values[5].response;
              if(!vm.pedido.dataHoraAgendamento) vm.pedido.dataHoraAgendamento = new Date().getTime();
              if(vm.pedido.numero) vm.pedido.numero = vm.pedido.numero.substring(2);

              if(vm.pedido.previsaoChegadaColaborador) {
                vm.pedido.atrazado = moment(vm.pedido.previsaoChegadaColaborador).isBefore(moment());
              }

              if(vm.pedido.dataHoraAgendamentoColeta) {

                return Encomenda.buscarHorariosAgendamentoColeta(vm.pedido.dataHoraAgendamento, vm.user.id).then(function(horarios){
                  vm.horarios = horarios;
                  vm.pedido.dataAgendamentoColeta = moment(vm.pedido.dataHoraAgendamentoColeta).format("YYYYMMDD");

                  var range = Coleta.getHoraRange(vm.pedido.dataHoraAgendamentoColeta, vm.horarios);
                  vm.pedido.horaInicialAgendamentoColeta = range.inicio;
                  vm.pedido.horaFinalAgendamentoColeta = range.fim;

                  var hoje = moment(new Date()).format('YYYYMMDD');
                  vm.pedido.coletaHoje = moment(vm.pedido.dataAgendamentoColeta).isSame(hoje);
                  vm.pedido.coletaAtrasada = moment(vm.pedido.dataAgendamentoColeta).isBefore(hoje);
                  vm.pedido.coletaDepoisHoje = moment(vm.pedido.dataAgendamentoColeta).isAfter(hoje);

                  return atualizarStatusView();
                });
              } else {
                return atualizarStatusView();
              }
            })
            .catch(function(err){
              atualizarStatusView();
            });
          }

          function atualizarStatusView() {
            vm.mostrarColeta = false;
            vm.mostrarCarregando = false;
            vm.mostrarAgendarColeta = false;
            vm.mostrarColetaAgendadaOnDemand = false;
            vm.mostrarColetaAgendadaProgramada = false;

            var coletaConcluida = vm.situacoesConcluidas.indexOf(vm.pedido.codigoSituacao) != -1;

            if(vm.pedido.coletaAtrasada && !coletaConcluida) {
              return;
            } else if(vm.user.freedomProgramada && !coletaConcluida) {
              vm.mostrarColetaAgendadaProgramada = true;
            } else if(vm.pedido.codigoSituacao == 'Incompleta') {
              vm.mostrarAgendarColeta = true;
            } else if(vm.pedido.codigoSituacao != 'Incompleta') {
              vm.mostrarColetaAgendadaOnDemand = true;
            }

            vm.mostrarColeta = true;
            vm.mostrarCarregando = false;

          }

          vm.atualizarColeta();

          vm.abrirModalAgendamentoColeta = function() {
            if(vm.user.situacao == 'BLOQUEADO') {
              $uibModal.open({
                animation: false,
                template: require('../../modal/modal-servico-suspenso/modal-servico-suspenso.html'),
                controller: 'ModalServicoSuspensoCtrl',
                windowClass: 'agendamento-coleta-bloqueado',
                  resolve: {
                    redirectToEncomendas: function() { return false; },
                    nomeOperacao: function() { return 'o envio de suas encomendas'; }
                  }
              });
            } else {
              Encomenda.podeMudarAgendamento(vm.pedido.id)
              .then(function(data){
                if(!data.pode){
                  abrirModalBloqueioPorHora('reagendamento');
                } else {
                  $uibModal.open({
                    animation: false,
                    templateUrl: 'modalAgendamentoColeta.html',
                    controller: 'ModalAgendamentoColetaController',
                    windowClass: 'agendamento-coleta',
                    resolve: {
                      horarios: function() { return Encomenda.buscarHorariosAgendamentoColeta(null, vm.user.id ); },
                      dataHoraAgendamentoColeta: function() { return vm.pedido.dataHoraAgendamentoColeta; },
                      pedidoInfo: function() { return  vm.pedido; },
                      pedidoId: function() { return vm.pedido.id; },
                      codigoSituacao: function() { return vm.pedido.codigoSituacao; },
                      user: function() { return vm.user; }
                    }
                  })
                  .result
                  .then(function(result) {
                    showAlert("Coleta agendada com sucesso!");
                    vm.atualizar();
                  })
                  .catch(function(err) {
                    if(err.message) showAlert(err.message);
                    vm.atualizar();
                  });
                }
              });
            }
          }

          vm.abrirModalCancelamentoColeta = function() {
            Encomenda.podeMudarAgendamento(vm.pedido.id)
            .then(function(data){
                $uibModal.open({
                  animation: false,
                  templateUrl: (data.pode ? 'modalCancelamentoColeta.html' : 'modalCancelamentoColetaAvisoCobranca.html'),
                  controller: 'ModalCancelamentoColetaController',
                  windowClass: 'cancelamento-agendamento-coleta',
                  resolve: {
                    pedidoInfo: function () { return vm.pedido; },
                    pedidoId: function() { return vm.pedido.id }
                  }
                })
                .result
                .then(function(result) {
                  showAlert("Agendamento foi cancelado com sucesso!");
                  vm.atualizar();
                })
                .catch(function(err){
                  if(err.status !== 422)
                    showAlert("Não foi possível cancelar a coleta no momento.");

                  const error = err.data.error;
                  if(error.message)
                    showAlert(err.message);
                });
            });
          }

          vm.abrirModalCancelamentoColetaProgramada = function() {
            Encomenda.podeMudarAgendamento(vm.pedido.id)
              .then(function(data){
                  $uibModal.open({
                    animation: false,
                    templateUrl: (data.pode ? 'modalCancelamentoColetaProgramada.html' : 'modalCancelamentoColetaAvisoCobranca.html'),
                    controller: 'ModalCancelamentoColetaController',
                    windowClass: 'cancelamento-agendamento-coleta',
                    resolve: {
                      pedidoInfo: function () { return vm.pedido; },
                      pedidoId: function() { return vm.pedido.id }
                    }
                  })
                  .result
                  .then(function(result) {
                    showAlert("Agendamento cancelado com sucesso!");
                    vm.atualizarColeta()
                    .then(function(data){
                      $timeout(function() {
                        vm.pedido.reagendado = true;
                        $timeout(function() {
                          vm.pedido.reagendado = false;
                        }, 500);
                      }, 500);
                    });
                  })
                  .catch(function(err) {
                    if(err.status !== 422)
                      showAlert("Não foi possível cancelar a coleta no momento.");

                    const error = err.data.error;
                    if(error.code == 'CLT00009')
                      showAlert("Não é possível cancelar coletas que se encontram em atraso.");
                    else if(error.code == 'CLT00010')
                      showAlert("Atualmente não é possível cancelar coletas com mais de 1 dia de antecedência.");
                    else if(error.message)
                      showAlert(error.message);
                  });
              });
          }

          function abrirModalBloqueioPorHora(acao){
            var horasAntecendencia = 3;
            $uibModal.open({
              animation: false,
              template: require('../../modal/modal-bloqueio-por-horario/modal-bloqueio-por-horario.html'),
              controller: 'ModalBloqueioPorHorarioCtrl',
              windowClass: 'agendamento-bloqueio-por-horario',
              resolve: {
                operacao: function() { return acao; },
                horasAntecendencia: function() { return horasAntecendencia;}
              }
            });
          }

          function showAlert(content) {
            var toast = $mdToast.simple()
              .textContent(content)
              .highlightAction(true)
              .parent('[data-container="toast"]')
              .position('top right')
              .hideDelay(5000);

            return $mdToast.show(toast);
          }
      };

      return {
          restrict: 'E',
          scope: {
            pedidoId: '='
          },
          controller: controller,
          controllerAs: 'vm',
          template: require('./coleta.html')
      };
  }

  function ModalAgendamentoColetaController($scope, $rootScope, $uibModal, $uibModalInstance, Encomenda, Coleta, horarios, dataHoraAgendamentoColeta, pedidoId, codigoSituacao, user, pedidoInfo) {
    $scope.numeroOS = pedidoInfo.numero;
    $scope.dataHoraAgendamentoColetaAntiga = null;

    if ( pedidoInfo.dataHoraAgendamentoColeta != null ) {
      $scope.dataHoraAgendamentoColetaAntiga = moment(pedidoInfo.dataHoraAgendamentoColeta).format("YYYY-MM-DD HH:mm:ss");
    }

    $scope.user = user;
    $scope.horarios = horarios;
    $scope.horarios.forEach(function(dia){
      dia.id = uuidv4();
      dia.horarios.forEach(function(range) {
        range.id = uuidv4();
      })
    });

    $scope.pedidoId = pedidoId;
    $scope.codigoSituacao = codigoSituacao;
    $scope.dataHoraAgendamentoColeta = dataHoraAgendamentoColeta;
    $scope.dataAgendada = Coleta.getData($scope.dataHoraAgendamentoColeta, $scope.horarios);
    $scope.horarioAgendado = Coleta.getHoraRange($scope.dataHoraAgendamentoColeta, $scope.horarios);

    $scope.confirmar = function() {
      if(!$scope.user.ativo) {
        $uibModalInstance.close({});
        $uibModal.open({
          animation: false,
          templateUrl: 'modalAgendamentoColetaDemoController.html',
          controller: 'ModalAgendamentoColetaDemoController',
          windowClass: 'confirmacao-agendamento-coleta-demo',
          resolve: { valor: function() { return ""; } }
        });

      } else if($scope.codigoSituacao != 'Incompleta') {
        $uibModal.open({
          animation: false,
          templateUrl: 'modalConfirmacaoAgendamentoColeta.html',
          controller: 'ModalConfirmacaoAgendamentoColetaController',
          windowClass: 'confirmacao-agendamento-coleta',
          resolve: {
            pedidoId: function() { return $scope.pedidoId },
            horario: function() { return Coleta.toInitialDate($scope.dataAgendada, $scope.horarioAgendado); }
          }
        })
        .result
        .then(onConfirmed);
      } else {
        onConfirmed();
      }
    }

    function onConfirmed() {
      Encomenda.agendarColeta(
        $scope.pedidoId,
        $scope.numeroOS,
        $scope.dataHoraAgendamentoColetaAntiga,
        Coleta.toInitialDate($scope.dataAgendada, $scope.horarioAgendado),
        Coleta.toFinalDate($scope.dataAgendada, $scope.horarioAgendado))
      .then(function(data) {

        if(data.error) {
          throw data.error;
        }

        $uibModalInstance.close({});

      })
      .catch(function(err) {
        $uibModalInstance.dismiss(err);
      });
    }

    $scope.cancelar = function() {
      $uibModalInstance.dismiss('cancel');
    }

    $scope.selectHorarioVisivel = function(horarioVisivel) {
      $scope.horarioAgendado = horarioVisivel;
    }

    function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  }

  function ModalConfirmacaoAgendamentoColetaController($scope, $rootScope, $uibModalInstance) {

    $scope.confirmar = function() {
      $uibModalInstance.close({});
    }

    $scope.cancelar = function() {
      $uibModalInstance.dismiss('cancel');
    }

  }

  function ModalAgendamentoColetaDemoController($scope, $uibModalInstance) {
    $scope.cancelar = function() {
      $uibModalInstance.dismiss('cancel');
    }
  }


  function ModalCancelamentoColetaController($scope, $uibModalInstance, Encomenda, pedidoId, pedidoInfo) {

    $scope.pedidoId = pedidoId;
    $scope.numeroOS = pedidoInfo.numero;

    $scope.confirmar = function() {
      Encomenda.cancelarColeta(
        $scope.pedidoId,
        $scope.numeroOS
      )
      .then(function(data) {
        $uibModalInstance.close({});
      })
      .catch(function(err) {
        $uibModalInstance.dismiss(err);
      });
    }

    $scope.cancelar = function() {
      $uibModalInstance.dismiss('cancel');
    }

  }

  function prettySimpleDate() {
    function jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return function(data) {
      var date = moment(data);
      return date.format('DD') + ' de ' + jsUcfirst(date.format('MMMM')) + ' de ' + date.format('YYYY');
    }
  }

  function prettySimpleDateAndTime() {
    function jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return function(data) {
      var date = moment(data);
      return date.format('DD') + ' de ' + jsUcfirst(date.format('MMMM')) + ' de ' + date.format('YYYY') + ' - ' + date.format('HH:mm');
    }
  }

  function prettyDate() {
    function jsUcfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return function(data) {
      var date = moment(data, 'YYYYMMDD');
      return jsUcfirst(date.format('dddd')) + ', ' + date.format('DD') + ' de ' + jsUcfirst(date.format('MMMM'));
    }
  }

  function prettySimpleHour() {
    return function(data) {
      return moment(data).format('HH');
    }
  }

  function prettyHour() {
    return function(hora) {
      if (hora <= 24) {
        if(hora < 10){
          return "0" + hora + ":00"
        }

        return hora + ":00"
      } else if (moment(hora).isValid()) {
        return moment(hora).format('HH:mm');
      }

      return hora;
    }
  }

  angular
    .module('mandaeApp')
    .filter('prettyDate', prettyDate)
    .filter('prettyHour', prettyHour)
    .filter('prettySimpleHour', prettySimpleHour)
    .filter('prettySimpleDate', prettySimpleDate)
    .filter('prettySimpleDateAndTime', prettySimpleDateAndTime)
    .directive('coleta', coleta)
    .controller('ModalConfirmacaoAgendamentoColetaController', ModalConfirmacaoAgendamentoColetaController)
    .controller('ModalAgendamentoColetaDemoController', ModalAgendamentoColetaDemoController)
    .controller('ModalCancelamentoColetaController', ModalCancelamentoColetaController)
    .controller('ModalAgendamentoColetaController', ModalAgendamentoColetaController);

}());
